import { useState } from "react";
import { AIToolCallRecord } from "../types/ai.types";

// ---------------------------------------------------------------------------
// Collapsed pill showing each tool the model used — click to expand and see
// the input/result JSON. Same transparency Cursor gives for file reads.
// ---------------------------------------------------------------------------

export default function ToolCallChip({ tc }: { tc: AIToolCallRecord }) {
  const [open, setOpen] = useState(false);
  const state = tc.error
    ? "error"
    : tc.result !== undefined
    ? "ok"
    : "running";

  const colors: Record<string, { bg: string; fg: string; dot: string }> = {
    running: { bg: "#fff7ed", fg: "#9a3412", dot: "#f97316" },
    ok:      { bg: "#ecfdf5", fg: "#065f46", dot: "#10b981" },
    error:   { bg: "#fef2f2", fg: "#991b1b", dot: "#ef4444" },
  };
  const c = colors[state];

  return (
    <div
      style={{
        margin: "6px 0",
        border: "1px solid #00000014",
        borderRadius: 8,
        background: c.bg,
        color: c.fg,
        fontSize: 12,
      }}
    >
      <button
        onClick={() => setOpen((v) => !v)}
        style={{
          width: "100%",
          background: "transparent",
          border: 0,
          padding: "6px 10px",
          textAlign: "left",
          cursor: "pointer",
          color: "inherit",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: 999,
            background: c.dot,
            display: "inline-block",
          }}
        />
        <span style={{ fontWeight: 500 }}>{tc.name}</span>
        <span style={{ opacity: 0.6, marginLeft: "auto" }}>
          {state === "running" ? "running…" : state === "ok" ? "done" : "error"}
        </span>
      </button>
      {open && (
        <div
          style={{
            padding: "0 10px 10px 10px",
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            fontSize: 11,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          <div style={{ opacity: 0.7, marginTop: 4 }}>input</div>
          <pre style={{ margin: "2px 0 6px 0" }}>
            {JSON.stringify(tc.input ?? {}, null, 2)}
          </pre>
          <div style={{ opacity: 0.7 }}>{tc.error ? "error" : "result"}</div>
          <pre style={{ margin: "2px 0 0 0" }}>
            {JSON.stringify(tc.error ?? tc.result ?? null, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
